export default __webpack_public_path__ + "static/article-renovation-tips-and-insights-163a2c5f36a9fa587b46ab7bc96d0d55.jpg";